import { combineReducers } from 'redux';
import users from './entities/users';
import institutions from './entities/institutions';
import submissions from './entities/submissions';
import submissionDetail from './entities/submissionDetail';
import ui from './entities/ui';
import auth from './entities/auth';
import blackbox from './entities/blackbox';
import announcement from './entities/announcement';

export default combineReducers({
  users,
  institutions,
  ui,
  auth,
  submissions,
  submissionDetail,
  blackbox,
  announcement,
});
